import { StyledDecisionFooter } from "../../styles/StyledDecision";
import { PropTypes } from "prop-types";
import { useState, useEffect } from "react";
import { DecisionSlider } from "../DecisionList/DecisionSlider";
import { StyledPageHeader } from "../../styles/StyledPage";
import { useAppContext } from "../../context/appContext";

export default function DecisionFooter({ id, edit }) {
	const { items } = useAppContext(); 
	const [decisionsList, setDecisionsList] = useState();

	useEffect(() => {
		const ls = localStorage.getItem("decisionsList");
		if (ls) {
			const tempDecisionsList = JSON.parse(ls);
			setDecisionsList(tempDecisionsList.filter((e) => parseInt(e.id) !== parseInt(id)));
		}
	}, [id]);
	
	const canSee = (decision) => {
		if (items.userUnits[decision.unit.id]) return true;
		if (
		Array.isArray(decision.receiverUnits) &&
		decision.receiverUnits.some((u) => items.userUnits[u.id])
		) {
		return true;
		}
		return false;
  	};
	  useEffect(() => {
    const ls = localStorage.getItem("decisionsList");
		if (ls) {
		const parsed = JSON.parse(ls);
		const filtered = parsed
			.filter((e) => parseInt(e.id, 10) !== parseInt(id, 10))
			.filter(canSee);

		setDecisionsList(filtered);
		}
  	}, [id, items.userUnits]);

	return (
		<StyledDecisionFooter>
			{!edit && decisionsList && (
				<>
					<StyledPageHeader>
						<h4>More decisions</h4>
					</StyledPageHeader>
					<DecisionSlider decisionBody={true} data={decisionsList} clearSearchResults={false} />
				</>
			)}
		</StyledDecisionFooter>
	);
}

DecisionFooter.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	edit: PropTypes.bool,
};
